import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles'
import withWidth from '@material-ui/core/withWidth'
import styles from './styles'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import Snackbar from '@material-ui/core/Snackbar'
import { closeSnackBar } from '../../actions/snack-bar'
import { getUser } from 'actions/user'
import { setUser } from 'actions/authentication'
import Router from '../../routes'
import packageJson from '../../../package.json'
const { version } = packageJson
import { isEmpty } from 'lodash'
import { _loginSuccess } from 'actions/authentication'
import ItemDialog from 'dialogs/Item'
import { logout } from 'actions/authentication'
import { changeOrientation } from 'actions/window'
import { closeLoginDialog } from 'actions/login-dialog'
import API from 'store/api'
import { getUserTickets } from 'actions/event'
import ConfirmDialog from 'dialogs/Confirm'
import { changePopoutMode } from 'actions/window'
import { setAudioSetting, setVideoDisplay } from 'actions/stream'
import { _closeRemoteDialog } from 'actions/login-dialog'

class App extends Component {
  componentDidMount() {
    // on app mount we look to see if there is an authenticated user stored
    if (!isEmpty(this.props.authenticatedUser)) {
      // if there is an authenticated user store we do a lookup to get latest data
      this.props
        .dispatch(getUser(this.props.authenticatedUser.user_id))
        .then(res => {
          // we then update that user data so it's always fresh
          this.props.dispatch(setUser(res))
          // check if user needs to reset password
        })
    }
    window.top.postMessage(
      {
        liveApp: {
          action: 'getToken'
        }
      },
      '*'
    )
    window.top.postMessage(
      {
        liveApp: {
          action: 'getOrientation'
        }
      },
      '*'
    )
    window.onmessage = e => {
      if (typeof e.data === 'object' && e.data.hasOwnProperty('liveApp')) {
        console.log('e.data.liveApp.action')
        if (e.data.liveApp.action === 'receiveToken') {
          API.set('Authorization', e.data.liveApp.token)
          e.data.liveApp.user.token = e.data.liveApp.token
          this.props.dispatch(_loginSuccess(e.data.liveApp.user))
        }
        if (e.data.liveApp.action === 'loginDismissed') {
          // rejects login dialog deferred
          setTimeout(() => {
            this.props.dispatch(closeLoginDialog(false))
          }, 350)
        }
        if (e.data.liveApp.action === 'logout') {
          this.props.dispatch(logout())
        }
        if (e.data.liveApp.action === 'orientationChange') {
          this.props.dispatch(changeOrientation(e.data.liveApp.orientation))
        }
        if (e.data.liveApp.action === 'remoteControl') {
          console.log('HERE')
          this.props.dispatch(_closeRemoteDialog())
          this.props.dispatch(setVideoDisplay(false))
        }
        if (e.data.liveApp.action === 'popoutMode') {
          this.props.dispatch(changePopoutMode(e.data.liveApp.mode))
        }
        // if (e.data.liveApp.action === 'reloadUserTickets') {
        //   if (!isEmpty(this.props.authenticatedUser)) {
        //     this.props.dispatch(
        //       getUserTickets(
        //         this.props.authenticatedUser.user_id,
        //         this.props.event.auction_code
        //       )
        //     )
        //   }
        // }
        // this.send(e.data.liveApp.action)
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (
      isEmpty(prevProps.authenticatedUser) &&
      !isEmpty(this.props.authenticatedUser)
    ) {
      // resolves login dialog deferred
      this.props.dispatch(
        closeLoginDialog(true, this.props.authenticatedUser, this.props.token)
      )
    }
  }
  render() {
    const { classes } = this.props
    const snackBarOrigin =
      this.props.width === 'sm' || this.props.width === 'xs'
        ? { vertical: 'bottom', horizontal: 'left' }
        : { vertical: 'bottom', horizontal: 'left' }
    return (
      <div className={classes.app}>
        {/* REMOVE THIS CONTENT */}
        <Router />
        {/* REMOVE THIS CONTENT */}
        <div id="dialog-holder">
          {/* LEAVE THIS IN PLACE FOR DIALOGS TO POPULATE INTO */}
          <ItemDialog />
          <ConfirmDialog />
        </div>
        <Snackbar
          anchorOrigin={snackBarOrigin}
          open={this.props.snackBar.open}
          onClose={() => this.props.dispatch(closeSnackBar())}
          ContentProps={{
            'aria-describedby': 'message-id'
          }}
          autoHideDuration={this.props.snackBar.autoHideDuration}
          message={<span id="message-id">{this.props.snackBar.message}</span>}
        />
        <div className={classes.version} style={{ display: 'none' }}>
          {/* {navigator.platform} -  */}
          {version}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    snackBar: state.snackBar,
    authenticatedUser: state.authentication.authenticatedUser,
    pendingAction: state.window.pendingAction,
    event: state.event.event,
    token: state.authentication.token
  }
}

export default withRouter(
  compose(connect(mapStateToProps), withStyles(styles), withWidth())(App)
)



// WEBPACK FOOTER //
// ./src/components/App/index.jsx